import React, { useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useModal } from "../../../contexts/ModalContext";
export default function HealthcareFaq({ data, extraClass = ""  }) {
    const { openQueryModal } = useModal();

  const [activeKey, setActiveKey] = useState(null);
  if (!data) return null;
  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  return (
    <section className={`healthcare-faq ${extraClass}`}>
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="faq-inner">
              {data?.title && ( <h4 className="heading">{data.title}</h4>  )}
              {data?.description && (  <p>{data.description}</p>  )}
              <div className="faq-btn"> <Link  className="default-btn" onClick={openQueryModal}>  <span>{data.buttonText}</span>  </Link> </div> 
            </div>
          </div>
          {data?.faqs?.length > 0 && (
            <div className="col-md-8">
              <div className="faq-content">
                <Accordion activeKey={activeKey} className="heslthcare-faqs">
                  {data.faqs.map((item, index) => {
                    const key = index.toString();
                    const number = (index + 1).toString().padStart(2, "0");
                    return (
                      <Card key={index}  className={activeKey === key ? "active" : ""} >
                        <Card.Header>
                          <Accordion.Item eventKey={key}>
                            <Accordion.Header   as="span"   className="accor-btn-box"  onClick={() => handleToggle(key)} >
                              <label className="accor-text-head heading">  {number}. {item.question}   </label>
                              <span className="arrow"> {activeKey === key ? "−" : "+"}  </span>
                            </Accordion.Header>
                            <Accordion.Body>
                              <p>{item.answer}</p>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Card.Header>
                      </Card>
                    );
                  })}
                </Accordion>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
